import Grid2 from '@mui/material/Unstable_Grid2';
import Select from 'src/shared/components/Form/Select';
import { OnChange } from 'react-final-form-listeners';
import { mapCompaniesDataToSelect } from '../../utils/mapCompaniesDataToSelect';
import { Step } from '../../components/Step';
import { useGetCompaniesPaginateAllQuery } from 'src/shared/api/company';
import { required } from 'redux-form-validators';
import { useTranslation } from 'react-i18next';
import ApartmentIcon from '@mui/icons-material/Apartment';

type SelectCompanyProps = {
  setSelectedCompany: (value: string) => void;
};

export const SelectCompany = ({ setSelectedCompany }: SelectCompanyProps) => {
  const { data: companies } = useGetCompaniesPaginateAllQuery({ searchValue: '' });
  const { t } = useTranslation(['settings', 'form']);

  const handleCompanyChange = async (value: string) => {
    if (!value) {
      return;
    }
    setSelectedCompany(value);
  };

  return (
    <Step
      title={t('integration.to start', { ns: 'settings' })}
      subtitle={t(
        'integration.select a company and follow the steps. Repeat the process with the companies you want to synchronise',
        { ns: 'settings' }
      )}
      Icon={ApartmentIcon}
    >
      <Grid2 xs={12} sx={{ paddingLeft: 0, paddingRight: 0 }}>
        <Select
          sx={{ maxWidth: '300px' }}
          data={mapCompaniesDataToSelect(companies)}
          label={t('field.subsidiary', { ns: 'form' })}
          name="subsidiary"
          fieldProps={{ validate: required() }}
        />
        <OnChange name="subsidiary">{handleCompanyChange}</OnChange>
      </Grid2>
    </Step>
  );
};
